import { render } from "./Privacy.vue?vue&type=template&id=5652380f"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/Privacy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5652380f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5652380f', __exports__)) {
    console.log('reload')
    api.reload('5652380f', __exports__)
  }
  
  module.hot.accept("./Privacy.vue?vue&type=template&id=5652380f", () => {
    console.log('re-render')
    api.rerender('5652380f', render)
  })

}


export default __exports__